"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Container_1 = __importDefault(require("@mui/material/Container"));
const styles = require('./Container.module.scss');
const Container = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(Container_1.default, Object.assign({ classes: {
            fixed: `${styles.fixedOverride}`,
            maxWidthXs: `${styles.maxWidthXsOverride}`,
            maxWidthSm: `${styles.maxWidthSmOverride}`,
            maxWidthMd: `${styles.maxWidthMdOverride}`,
            maxWidthLg: `${styles.maxWidthLgOverride}`,
            maxWidthXl: `${styles.maxWidthXlOverride}`,
        } }, rest), children));
};
exports.default = Container;
//# sourceMappingURL=Container.js.map